import React, { useEffect, useRef } from 'react'
import mapImg from "../../../assets/contactImg.png"
import { gsap } from "gsap";

export default function Section1() {

    const contactRef = useRef(null);
    useEffect(()=>{

        const contactTitle1 = contactRef.current?.querySelector(".contactHeader1");
        gsap.fromTo(
        contactTitle1,
            {
                opacity: 0,
                y: -40,
            },
            {
                opacity: 1,
                y: 0,
                delay :0.2,
                duration : 0.5,
                ease: 'power2.out',
            }
        );

        const contactTitle2 = contactRef.current?.querySelector(".contactHeader2");
        gsap.fromTo(
        contactTitle2,
        {
            opacity: 0,
            y: -40,
        },
        {
            opacity: 1,
            y: 0,
            delay :0.2,
            duration : 0.7,
            ease: 'power2.out',
        }
        );
        
        const contactImg = contactRef.current?.querySelector(".contactImg");
        gsap.fromTo(
            contactImg,
            {
                opacity: 0,
            },
            {
                opacity: 1,
                delay :0.4,
                duration : 1,
                ease: 'power2.out',
            }
        );

        const cardItem1 = contactRef.current?.querySelector(".cardItem1");
        gsap.fromTo(
            cardItem1,
            {
                opacity: 0,
                x : -500
            },
            {
                x : 0,
                opacity: 1,
                delay : 0.6,
                duration :1,
                ease: 'power2.out',
            }
        );
        const cardItem2 = contactRef.current?.querySelector(".cardItem2");
        gsap.fromTo(
            cardItem2,
            {
                opacity: 0,
                x : -400
            },
            {
                x : 0,
                opacity: 1,
                delay : 0.8,
                duration :1,
                ease: 'power2.out',
            }
        );
        const cardItem3 = contactRef.current?.querySelector(".cardItem3");
        gsap.fromTo(
            cardItem3,
            {
                opacity: 0,
                x : -300
            },
            {
                x : 0,
                opacity: 1,
                delay : 1.0,
                duration :1,
                ease: 'power2.out',
            }
        );


    },[]);


  return (
    <div className='w-full mt-10 lg:mt-[30px]' ref = {contactRef} >

        <div className='text-center'>
            {/* <h4 className='text-[#FF5A5F] font-bold contactHeader1'>
                Contact Us
            </h4> */}
            <h2 className='mt-5 font-bold text-2xl lg:text-6xl text-[#3A3A3A] contactHeader2'>
                We'd love to hear from you 
            </h2>
        </div>

        <div className='mt-8 w-full h-fit lg:h-[400px] flex justify-center items-center m-auto px-4 contactImg'>
            <img src={mapImg} className='w-full h-full object-contain' alt="Error" title="Contact" />
        </div>

        <div className='mt-8 flex flex-col lg:flex-row justify-center text-center gap-[80px]'>

            <div className='flex flex-col gap-4 cardItem1'>
                <h4 className='text-xl font-bold text-[#FF5A5F]'>Phone No.</h4>
                <h4 className='text-lg tracking-wider'>Our Friendly Team is here to help</h4>
                <div className='flex gap-4 flex-col lg:flex-row'>
                    <h4 className='text-md'>+91-9706602548</h4>
                    <h4 className='text-md'>+91-9893134512</h4>
                </div>
            </div>

            <div className='flex flex-col gap-4 cardItem2'>
                <h4 className='text-xl font-bold text-[#FF5A5F]'>E-mail</h4>
                <h4 className='text-lg tracking-wider'>Question or Queries Get in Touch</h4>
                <div className='flex flex-col lg:flex-row gap-4'>
                    <h4 className='text-md'>ravi@alfredsolutions.com</h4>
                    <h4 className='text-md'>prakhar@alfredsolutions.com</h4>
                </div>
               
            </div>

            <div className='flex flex-col gap-4 cardItem3'>

                <h4 className='text-xl font-bold text-[#FF5A5F]'>Google Form & Links</h4>
                <h4 className='text-lg tracking-wider'>Fill Out Form or Connect on LinkedIn</h4>
                
                <div className='flex flex-col lg:flex-row gap-4 justify-center'>
                    <a href="https://docs.google.com/forms/d/e/1FAIpQLSfMdNOuWmgFd6ilio1jc9z_fvEl5AC5M8_nZwGpdHGNKQV5Iw/viewform"
                    target = "_blank" 
                    rel = "noreferrer"
                    >
                        <h4 className='text-md '>Form</h4>
                    </a>
                    <a href="https://www.linkedin.com/company/thealfredapp/"
                    target = "_blank" 
                    rel = "noreferrer"
                    >
                        <h4 className='text-md '>LinkedIn</h4>
                    </a>
                </div>

            </div>

 
        </div>


    </div>
  )
}
